import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import { getVendorsList, deleteVendor } from '../../api/vendors';
import Preloader from '../../common/Preloader';
import hasAccess from "../../helpers/permissionChecker";

export class Vendors extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handlerMaterials = this.handlerMaterials.bind(this);
    this.addVendor = this.addVendor.bind(this);
    this.getVendors = this.getVendors.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      currentPage: 0,
    };

    this.columns = [
      'name',
      'created',
    ];

    this.columnNames = [
      'Name',
      'Date Created',
    ];
  }

  addVendor() {
    this.props.moveToAdd();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  componentDidMount() {
    this.props.loadList();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteVendor,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteVendor',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  handlerMaterials(id) {
    this.props.moveToMaterials(id);
  }

  getVendors() {
    const vendorsList = path(['vendors', 'list'], this.props);

    if (!vendorsList) {
      return null;
    }

    const itemActions = {
      materials: {
        handler: this.handlerMaterials,
        permission: { 'permAreaKey': 'materials_inventory', 'permTypeKey': 'view' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-table icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'materials',
      },
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        permission: { 'permAreaKey': 'vendor', 'permTypeKey': 'edit' },
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'vendor', 'permTypeKey': 'delete' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    return (
      <Table
        items={vendorsList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />
    );
  }

  render() {
    const vendors = this.getVendors();
    let preloader = null;

    if (vendors === null) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'person_pin', name: 'Vendors' },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            Vendors
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'vendor', 'permTypeKey': 'create' }) &&
              <div className="clearfix mb-3">
                <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addVendor}>
                  <i className="material-icons">add_circle_outline</i>
                  <span className="color-default">Add</span>
                </button>
              </div>
            }
            {preloader}
            {vendors}
            <ConfirmAction id={'deleteVendor'} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadList: () => {
      getVendorsList()(dispatch)
    },
    moveToMaterials: (id) => {
      dispatch(push('/pages/materials?vendor=' + id));
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/vendor/' + id));
    },
    moveToAdd: () => {
      dispatch(push('/pages/vendor'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Vendors);



// WEBPACK FOOTER //
// ./src/containers/Vendors/index.js